
import { defineComponent } from "vue";
import $ from "jquery";
import { AutoaddressResponse, FindAddressResponse } from "@/types/autoaddress";
import Autoaddress from "@autoaddress.ie/autoaddress-vue/src/Autoaddress.vue";
import { autoaddressAddressResult } from "@/util/locationFactory";
import {
  useAutoaddress,
  useGammaWebServices,
  useLocation,
  useOrgSettings,
} from "@/services";

export default defineComponent({
  name: "AutoaddressSearch",
  components: {
    Autoaddress,
  },
  props: {
    country: {
      type: String,
      default: "ie",
    },
  },
  computed: {
    localCountry(): string {
      return this.country.toLowerCase();
    },
    licenseKey(): string | undefined {
      return useOrgSettings().autoAddressProvider?.licenceKey;
    },
  },
  methods: {
    aaInit() {
      $(".autoaddress-control")
        .addClass("input-group")
        .prepend($(".autoaddress-autocomplete"));
      $(".autoaddress-text-box")
        .addClass("form-control")
        .attr("aria-label", "Address searchbox");
      $(".autoaddress-button")
        .addClass("btn btn-primary")
        .css({ height: "auto" })
        .wrap('<div class="input-group-append"></div>');
      $(".input-group-append").prepend('<span class="autoAddress-search" />');

      (this.$refs.autoaddress as any).$el
        .getElementsByTagName("input")[0]
        .setAttribute("autocomplete", "none");
    },
    async getLatLng(result: FindAddressResponse) {
      const ecadData = await useAutoaddress().getLatLng({
        ecadid: result.addressId,
        postcode: result.postcode || "",
        country: this.localCountry,
      });
      const location = autoaddressAddressResult({
        findAddress: result,
        data: ecadData,
      } as AutoaddressResponse);
      useLocation().updateLocation(location).then();

      if (result.result.code === 210) {
        useLocation().updateLocation(null);
        useGammaWebServices().clearScores();
      }
    },
  },
});
